/* Добавляем параметр для принудительного скачивания файла, вместо открытия в браузере через встроенный просмотрщик */
const addForceDownloadHeaderParam = (href: string) =>
    href.includes('?')
        ? `${href}&response-content-disposition=attachment`
        : `${href}?response-content-disposition=attachment`;

export const downloadFile = (href: string, newTab: boolean = false) => {
    const link = document.createElement('a');

    const downloadUrl = addForceDownloadHeaderParam(href);

    link.href = downloadUrl;
    link.download = '';

    link.style.display = 'none';

    if (newTab) {
        link.target = '_blank';
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
